const addPathPrefix = (prefix: string | undefined | null | boolean, property: string | null | undefined) => {
    const dotOnTheEndOfPrefix = prefix?.toString().at(-1) === '.';

    return `${prefix !== true && prefix ? prefix + (dotOnTheEndOfPrefix ? '' : '.') : ''}${property ?? ''}`;
};

export default addPathPrefix;
